class EmailVerificationError extends Error {
    
}

export default EmailVerificationError;